module.exports = __webpack_public_path__ + "static/media/laptopCheckList.b06c1361.png";